<mat-calendar
  class="calendar-range"
  [selected]="selectedRangeValue"
  (selectedChange)="selectedChange($event)"
></mat-calendar>

<section>
  <mat-form-field appearance="fill">
    <mat-label>Start time</mat-label>
    <mat-select [(value)]="startTime" [disabled]="!selectedRangeValue?.start">
      <mat-option
        *ngFor="let interval of hourIntervals"
        [value]="interval.milliseconds"
      >
        {{ interval.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-checkbox
    [disabled]="!selectedRangeValue?.start"
    [(ngModel)]="startBoundaryInclusive"
    >Inclusive start</mat-checkbox
  >
</section>

<section>
  <mat-form-field appearance="fill">
    <mat-label>End time</mat-label>
    <mat-select [(value)]="endTime" [disabled]="!selectedRangeValue?.end">
      <mat-option
        *ngFor="let interval of hourIntervals"
        [value]="interval.milliseconds"
      >
        {{ interval.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-checkbox
    [disabled]="!selectedRangeValue?.end"
    [(ngModel)]="endBoundaryInclusive"
    >Inclusive end</mat-checkbox
  >
</section>

<mat-form-field appearance="fill">
  <mat-label>Time zone</mat-label>
  <mat-select [(value)]="selectedTimeZone">
    <mat-option *ngFor="let timezone of uniqueTimezones" [value]="timezone">
      {{ timezone.offsetString }}
    </mat-option>
  </mat-select>
</mat-form-field>

<button mat-button (click)="close()">Cancel</button>
<button mat-raised-button [mat-dialog-close]="getDateRange()" color="primary">
  Save
</button>
